module.exports = __webpack_public_path__ + "static/media/12UNCTAD1.086c4044.jpg";